import {removeTimezone} from "./Formater";

const EXCLUDED_COUNTER_ACCOUNT = ["261001", "568001", "662001", "562001","311001","314001","315001", "315100","321001","331001",
  "336001","342001", "343999", "461001", "602001", "648001", "668001","314006","315005","324005", "325002","325003","341000",
"341001", "379002", "395000", "538001", "548100", "221002"];
const EXCLUDED_COUNTER_ACCOUNT_STARTS_WITH = ["518"];
const EXCLUDED_COMPANIES = ["5", "6", "25"];
const MIN_YEAR = 2024;

export function filterBankList(bankList, companyCode) {
  if (EXCLUDED_COMPANIES.includes(companyCode)) {
    return [];
  }
  return bankList.filter(
    (bank) =>
      !EXCLUDED_COUNTER_ACCOUNT.includes(bank.counterAccount) &&
      !EXCLUDED_COUNTER_ACCOUNT_STARTS_WITH.some((start) =>
        bank.counterAccount.startsWith(start)
      ) &&
      new Date(removeTimezone(bank.expoDate)).getFullYear() >= MIN_YEAR
  );
}